export const AMP_MODAL = {
    TITLE: 'Your Choice AMP Tag',
    DESCRIPTION: `Implement your Choice AMP Tag at the top of the body on your
          AMP-powered web page. If you need to implement CCPA or you want to
          display GDPR only in EU, check the AMP Instructions document at the
          top of this popup.`,
    PERSISTENT_CONSENT_LINK_STYLES_DESCRIPTION: 'Persistent consent link styles. Please paste this code inside the head tag of your page:',
    COPY_TAG: 'Copy Tag',
    COPY_STYLES: 'Copy Styles',
    TAG_COPIED_TO_CLIPBOARD: 'Tag copied to clipboard',
    STYLES_COPIED_TO_CLIPBOARD: 'Styles copied to clipboard',
}

export const CMP_USER_MODAL = {
    TITLE: '🎉 Access More with Your Existing InMobi Login',
    DESCRIPTION: `We’ve made things simpler — your existing InMobi CMP credentials can
            now be used to sign in to the InMobi Supply Side Platform (SSP) as
            well. No need to create a new account — just log in with your
            current details to explore privacy-first monetization solutions.`,
    LEARN_MORE_LINK: 'Learn more about it',
    PUBLISHER_POLICY_LINK: 'InMobi’s Publisher Policy',
    CONTINUE_USING_CMP_LINK: 'Continue using InMobi CMP',
    MONETIZE_SMARTER_WITH_INMOBI_SSP: 'Monetize Smarter with InMobi Supply Side Platform',
    FULL_FUNNEL_DEMAND: 'Tap into full-funnel demand, drive higher yield with quality ads and addressable audiences, and scale with flexible, privacy- first integrations.',
    TO_CONTINUE: `To continue, please review and agree to the Terms & Conditions of`,
    AGREE_AND_PROCEED: 'Agree & Proceed',
}

export const DYNAMIC_BREADCRUMB = {
    MY_PROPERTIES: 'My Properties',
    CREATE_PROPERTY: 'Create Property',
    EDIT_PROPERTY: 'Edit Property',
    MY_THEMES: 'My Themes',
    CREATE_THEME: 'Create Theme',
    EDIT_THEME: 'Edit Theme',
}

export const CUSTOMIZE_PRIVACY = {
    TCF_2_2_2_3_WARNING: 'You may use this option to set TCF to 2.3. To comply with TCF v2.3, set VENDORS DISCLOSED to Yes in Regulation Details Tab in property settings.',
};

export const CREATE_CUSTOMER_MODAL = {
    TITLE: `You're Almost There — Just Confirm Your Details`,
    DESCRIPTION: 'We just need to double-check your info before we send you to our secure payment partner. These details will be used to set up your Premium subscription.',
    FIRST_NAME_LABEL: 'First Name',
    FIRST_NAME_PLACEHOLDER: 'Enter your first name',
    FIRST_NAME_REQUIRED: 'Please enter your first name',
    LAST_NAME_LABEL: 'Last Name',
    LAST_NAME_PLACEHOLDER: 'Enter your last name',
    LAST_NAME_REQUIRED: 'Please enter your last name',
    EMAIL_LABEL: 'Email',
    EMAIL_PLACEHOLDER: 'Enter your email address',
    EMAIL_REQUIRED: 'Please enter your email',
    EMAIL_INVALID: 'Please enter a valid email address',
    COMPANY_NAME_LABEL: 'Company Name',
    COMPANY_NAME_PLACEHOLDER: 'Enter your company name',
    COMPANY_NAME_REQUIRED: 'Please enter your company name',
    CANCEL_BUTTON: 'Cancel',
    SUBMIT_BUTTON: 'Confirm & Continue',
    SUCCESS_MESSAGE: 'Customer account created successfully!',
    ERROR_MESSAGE: 'Failed to create customer account. Please try again.',
    TERMS_AND_CONDITIONS_LABEL_PREFIX: "I acknowledge that I have read and agree to the updated InMobi Consent Management Platform ",
    TERMS_AND_CONDITIONS_LINK_TEXT: "Terms and Conditions",
    TERMS_AND_CONDITIONS_URL: "https://advertising.inmobi.com/cmp-terms",
    TERMS_AND_CONDITIONS_LABEL_MIDDLE: " and ",
    PRIVACY_POLICY_LINK_TEXT: "Privacy Policy",
    PRIVACY_POLICY_URL: "https://advertising.inmobi.com/privacy-policy",
    TERMS_AND_CONDITIONS_LABEL_SUFFIX: ", which govern access to premium features and the management of my subscription, including payment and billing processing. I understand that I may cancel my subscription at any time to opt-out of premium subscription plan",
    PRIVACY_POLICY_LABEL: "Your information is handled securely and only shared for payment-related purposes."
}

export const CANCEL_SUBSCRIPTION_MODAL = {
    TITLE: 'Are you sure you want to Cancel Subscription?',
    DESCRIPTION: 'Are you sure you want to cancel your subscription? This action cannot be undone.',
    NO_BUTTON: 'No, keep subscription',
    YES_BUTTON: 'Yes, cancel subscription',
    KEEP_PREMIUM: 'Keep Premium',
    INTEGRATE_WITH_SSP: 'Integrate with SSP',
    REASON_TITLE: "Tell us why you're cancelling",
    REASON_STATEMENT: "We're sorry to see you go. Before you cancel, please specify your reason of cancellation below: ",
    REASON_INTEGRATED_SSP: 'Integrated with InMobi SSP',
    REASON_PRICING: "The pricing doesn't work for us at the moment",
    REASON_MOVING_CMP: 'Moving to another CMP',
    REASON_INACTIVE: 'The site/app is no longer active or monetizing',
    REASON_OTHER: 'Other (please specify)',
    REASON_OTHER_PLACEHOLDER: 'Please specify your reason...',
    DISMISS_BUTTON: 'Dismiss',
    CANCEL_SUBSCRIPTION_BUTTON: 'Cancel Subscription'
}